export const FIELD_ID = {
  case: {
    plaintiffsRefList: 142482,
  },
  casePlaintiff: {
    firstName: 17305,
    lastName: 17307,
    source: 19320,
    dateClosed: 142506,
    totalBeginningExposure: 142509,
    totalEndExposure: 142510,
    settlementAmount: 142525,
    settlementDetailsRefList: 17333,
    agreement: 142530,
    currentDiagnosis: 142539,
    groupId: 142551,
    clientCode: 142581,
    logSequenceNumber: 142594,
    plaintiffCounsel: 1382709,
    defenseCounsel: 1382710,
    damagesSought: 1382810,
    courtRefList: 19322,
    nationalCounselBillingNumber: 2520993,
    nationalCounselBillingNumberTK: 3784296,
    court: {
      state: 6406,
      location: 6407,
      type: 6408,
    },
    settlementDetails: {
      settlementAmount: 23005,
    },
  },
  settlementLog: {
    partialPayment: 2103271,
    multiplePartialPaymentReason: 2103272,
    notes: 2140268,
  },
  monthEndDate: {
    monthEndDate: 5005,
    tableName: 5006,
  },
  timekeeper: {
    code: 2972782,
    firm: 2972790,
  },
}

export const CHOICE_VALUE = {
  plaintiffStatus: {
    closed: 7251,
  },
}

